import { ProjectSearchPageState } from ".";

export const ProjectSearchPageInitialState: ProjectSearchPageState = {
  pjtNameOrDesc: "",
  prdDplymntDateRange: {
    startDate: "",
    endDate: "",
  },
  stgDplymntDateRange: {
    startDate: "",
    endDate: "",
  },
  pjtRgstrDateRange: {
    startDate: "",
    endDate: "",
  },
  pjtStsList: ["1"],
  pjtLnchTypeList: ["Regular"],
  dipList: [],
  isPmyOnly: "",
  userId: "",
  userName: "",
  cpntIdList: [],

  displayedSearchForm: true,

  fieldPath: {
    pjtNameOrDesc: "pjtNameOrDesc",
    prdDplymntDateRangFrom: "prdDplymntDateRangFrom",
    prdDplymntDateRangTo: "prdDplymntDateRangTo",
    stgDplymntDateRangFrom: "stgDplymntDateRangFrom",
    stgDplymntDateRangTo: "stgDplymntDateRangTo",
    pjtRgstrDateRangFrom: "pjtRgstrDateRangFrom",
    pjtRgstrDateRangTo: "pjtRgstrDateRangTo",
    pjtStsList: "pjtStsList",
    pjtLnchTypeList: "pjtLnchTypeList",
    dipList: "dipList",
    isPmyOnly: "isPmyOnly",
    userId: "userId",
    userName: "userName",
    cpntIdList: "cpntIdList",
  },
  searchResult: {
    projectList: [],
  },
};
